import { request } from '@/utils/request';


// 获取区划管理员账号表格数据
export function getZoneIdentityTable (params) {
  return request('/api/zlbuser/administrator/tenant/manager/list', {
    params,
    method: 'get',
  });
}

// --------------- 新增、编辑身份操作 ---------------

// 校验手机号 + 租户
export function checkMobileAndTenant (params) {
  return request('/api/zlbuser/administrator/tenant/manager/unique/info', {
    params,
    method: 'get',
  });
}

// 新增区划管理员账号
export function addZoneIdentityAccount (data) {
  return request('/api/zlbuser/administrator/tenant/manager', {
    data,
    method: 'post',
  });
}

// 更新区划管理员账号
export function updateZoneIdentityAccount (data) {
  const { operatorId } = data;
  return request(`/api/zlbuser/administrator/tenant/manager/${operatorId}`, {
    data,
    method: 'post',
  });
}

// --------------- 表格删除、停启用操作 ---------------

// 删除区划管理员账号
export function deleteZoningAccount (data) {
  const { operatorId } = data;
  return request(`/api/zlbuser/administrator/tenant/manager/${operatorId}`, {
    data,
    method: 'delete',
  });
}

// 停用启用账号
export function enableDeactivateAccount (data) {
  return request('/api/zlbuser/administrator/tenant/manager/state', {
    data,
    method: 'post',
  });
}


// --------------- 设置岗位 ---------------

// 获取岗位功能树
export function getPositionsTree (params) {
  return request('/api/workbench/privileges/position/tree', {
    params,
    method: 'get',
  });
}

// 获取岗位功能树
export function getPositionsRole (params) {
  return request('/api/workbench/positionManager/getPositionsRoles', {
    params,
    method: 'get',
  });
}

export function getPositionsRoleForZoning (params) {
  return request('/api/workbench/posts/subscribe/list', {
    params,
    method: 'get',
  });
}

// 租户侧设置岗位
export function addOptRoleForZoning (params) {
  return request('/api/workbench/positionManager/role/group/modify', {
    method: 'post',
    data: params,
  });
}


// --------------- 数据权限 ---------------

// 获取数据规则
export function setInstitutionDataRules (data) {
  return request('/api/zlbuser/administrator/tenant/manager/dataRule', {
    data,
    method: 'post',
  });
}

export function getParentDistrictCode (tenantCode) {
  return request(`/zlb/api/sop/manage/query-parent-tenant-code/${tenantCode}`, {
    method: 'get',
  });
}